import { AccountView } from '../../../types/entity-types';
import { getSyncStatusText } from '../../../utils/get-sync-status-text';

export type LastSyncData = {
  text: string;
  lastSyncAttemptAt: Date | null;
  account?: {
    id: string;
    name?: string;
  };
} | null;

export const getTimeSinceLastSyncFromAccount = (account: AccountView): LastSyncData => {
  const syncText = getSyncStatusText({
    status: account.syncResult.syncStatus,
    lastSyncAttemptAt: account.syncResult.lastSyncAttemptAt,
    nextSyncAt: account.syncResult.nextSyncAt,
  });

  if (!syncText) {
    return null;
  }

  return {
    text: syncText,
    lastSyncAttemptAt: account.syncResult.lastSyncAttemptAt || null,
    account: {
      id: account.id,
      name: account.name,
    },
  };
};

export const getTimeSinceLastSyncFromAccounts = (accounts: AccountView[]): LastSyncData => {
  if (accounts.length === 0) {
    return null;
  }

  // Find account with most recent sync
  const mostRecentAccount = accounts.reduce((mostRecent, current) => {
    if (!current.syncResult.lastSyncAttemptAt) {
      return mostRecent;
    }
    if (!mostRecent || !mostRecent.syncResult.lastSyncAttemptAt) {
      return current;
    }
    return current.syncResult.lastSyncAttemptAt > mostRecent.syncResult.lastSyncAttemptAt ? current : mostRecent;
  }, accounts[0]);

  return getTimeSinceLastSyncFromAccount(mostRecentAccount);
};
